import "../styles/UtahVerticals.css";
import ActionButton from "../utils/ActionButton";
import ActionButton1 from "../utils/ActionButton1";
import Footer from "../components/Footer";
import LandingSection from "../components/LandingSection";
import { Link } from "react-router-dom";
import { ResponsiveContainer } from "recharts";
import GDP3DPieChart from "./chart";
import InfoIcon from "@mui/icons-material/Info";

const verticals = [
  {
    title: "Real Estate and Rental and Leasing",
    description:
      "Utah’s real estate market continues to grow rapidly, driven by population expansion, economic strength, and quality of life.",
    imagesrc: "/img/verticals/real-estate.webp",
    link: "/wip",
    gdp: 40.26,
  },
  {
    title: "Manufacturing",
    description:
      "Advanced manufacturing thrives in Utah from precision equipment to sustainable materials. The sector is vital to exports and job creation.",
    imagesrc: "/img/verticals/Manufacturing.webp",
    link: "/verticals/manufacturing ",
    gdp: 29.13,
  },
  {
    title: "Aerospace and Defense",
    description:
      "Utah is home to leading aerospace firms and military operations. This sector supports national defense and innovation in space technologies.",
    imagesrc: "/img/verticals/aerospace (1).webp",
    link: "/verticals/aerospace-and-defense ",
    gdp: 4.43,
  },
  {
    title: "Food Industry",
    description:
      "Utah's food industry is a vital economic driver, blending agriculture, processing, and innovation to support jobs and statewide growth.",
    imagesrc: "/img/verticals/FoodIndustry.webp",
    link: "/verticals/food-industry ",
    gdp: 2.74,
  },
  {
    title: "Government (Public Administration)",
    description:
      "Utah’s government sector plays a key role in maintaining public services, infrastructure, and community well-being.",
    imagesrc: "/img/verticals/govPA.webp",
    link: "/wip",
    gdp: 26.24,
  },
  {
    title: "Professional, Scientific, and Technical Services",
    description:
      "Utah's professional, scientific, and technical services sector is a fast-growing innovation hub known as the Silicon Slopes.",
    imagesrc: "/img/verticals/Engineering&Technology.webp",
    link: "/verticals/professional-scientific-and-technical-services",
    gdp: 23.81,
  },
  {
    title: "Healthcare and Social Assistance",
    description:
      "Healthcare professionals, researchers, and innovators support one of Utah’s most essential sectors driving public health and medical advancements.",
    imagesrc: "/img/verticals/HealthScience.webp",
    link: "/wip",
    gdp: 22.12,
  },
  {
    title: "Finance and Insurance",
    description:
      "Utah's finance and insurance sector is a dynamic hub for startups, entrepreneurship, and strategic brand growth.",
    imagesrc: "/img/verticals/BusinessFinance&Marketing.webp",
    link: "/wip",
    gdp: 21.64,
  },
  {
    title: "Retail Trade",
    description:
      "Utah’s retail trade sector is a dynamic contributor to the state’s economy, fueled by strong consumer spending and business growth.",
    imagesrc: "/img/verticals/retail.webp",
    link: "/wip",
    gdp: 18.42,
  },
  {
    title: "Wholesale Trade",
    description:
      "Utah’s wholesale trade sector serves as a vital link between manufacturers and retailers, supporting the state’s diverse industries.",
    imagesrc: "/img/verticals/wholesale.webp",
    link: "/wip",
    gdp: 17.07,
  },
  {
    title: "Information",
    description:
      "Utah's information sector is thriving, driving innovation in software, cybersecurity, and digital services.",
    imagesrc: "/img/verticals/Cs&It.webp",
    link: "/verticals/information",
    gdp: 15.69,
  },
  {
    title: "Construction",
    description:
      "Design meets durability in Utah’s construction sector, where skilled trades and architects are shaping cities and communities.",
    imagesrc: "/img/verticals/cons.webp",
    link: "/verticals/construction",
    gdp: 13.12,
  },
  {
    title: "Transportation and Warehousing",
    description:
      "Utah’s transportation and warehousing sector efficiently connects the region, driving economic growth through advanced infrastructure and strategic location.",
    imagesrc: "/img/verticals/Transportation.webp",
    link: "/verticals/transportation-and-warehousing",
    gdp: 9.7,
  },
  {
    title: "Utilities",
    description:
      "Utah’s utilities sector ensures reliable delivery of electricity, water, and natural gas to support the state’s growing population and industries.",
    imagesrc: "/img/verticals/utilities.webp",
    link: "/wip",
    gdp: 4.37,
  },
  {
    title: "Mining",
    description:
      "Utah’s mining industry plays a vital role in the state’s economy, producing essential resources like copper, coal, gold, and salt.",
    imagesrc: "/img/verticals/Mining.webp",
    link: "/verticals/mining",
    gdp: 3.94,
  },
  {
    title: "Arts, Entertainment, and Recreation",
    description:
      "Utah fosters creativity through media, design, and the arts where storytelling meets tech and culture.",
    imagesrc: "/img/verticals/Arts.webp",
    link: "/wip",
    gdp: 3.37,
  },
];

const UtahVerticals = () => {
  return (
    <>
      <LandingSection
        data={{
          imageName: "vertical.webp",
          title: "Utah Key Economic Verticals",
        }}
      />
      <div className="utah-at-a-glance-section">
        <div className="utah-at-a-glance-intro">
          <div className="utah-at-a-glance-intro-sec1">
            <h2>Explore the Core Industries Powering Utah’s Economy</h2>
          </div>
          <div className="utah-at-a-glance-intro-sec2">
            <p>
              Utah’s diverse economy is built on innovation, tradition, and
              forward-thinking industries. From aerospace to analytics, each
              vertical represents unique growth opportunities, workforce needs,
              and economic contributions. Dive into each sector to uncover data,
              career pathways, and strategic insights.
            </p>
          </div>
        </div>
      </div>

      <div className="w-full flex flex-col items-center py-10 ">
        <h2 className="text-2xl font-bold text-blue-700 mb-4">
          Utah’s GDP Contribution by Sector (2024)
        </h2>
        <p className="text-gray-600 mb-6 text-center max-w-2xl">
          The chart below represents the percentage contribution of each major
          industry to Utah’s overall Gross Domestic Product (GDP).
        </p>
        <div className="chart-responsive-box">
          <ResponsiveContainer width="100%" height="100%">
            <GDP3DPieChart />
          </ResponsiveContainer>
        </div>
        <div className="max-w-5xl mx-auto">
          <div className="text-sm md:text-base">
            <p className="flex items-start gap-2">
              <span className="mt-1">*</span>
              <span>
                <b>Utah's GDP</b> in 2024 reached approximately{" "}
                <b>$301 billion to $308 billion.</b>
              </span>
            </p>
            <p className="flex items-start gap-2">
              <span className="mt-1">*</span>
              <span>
                <b>Food Industry and Aerospace & Defense</b> are sub-sectors of
                the Manufacturing sector.
              </span>
            </p>
            <p className="flex items-start gap-2">
              <span className="mt-1">*</span>
              <span>
                <b>Other Verticals</b> include Administrative and support and
                waste management and remediation services, Accommodation and
                food services, Other services (except government and government
                enterprises), Educational services, Management of companies and
                enterprises, Agriculture, forestry, fishing and hunting.
              </span>
            </p>
          </div>
        </div>
        <div>
          <p className="flex gap-2 items-center">
            <spna>
              <InfoIcon style={{ color: "#014cb2" }} />
            </spna>
            <span>
              Following <b>Key Economic Verticals</b> are sorted in descending order:
            </span>
          </p>
        </div>
      </div>
      <div className="verticals_section mt-4">
        <div className="verticals-list">
          {verticals.map((item, index) => (
            <div key={index} className="vertical-item">
              <img
                src={item.imagesrc}
                className="hover-image"
                alt={item.imagesrc}
              />
              <div className="vertical-title">{item.title}</div>
              <div style={{ flex: 2 }}></div>
              <div
                className="vertical-description"
                style={{ minHeight: "96px" }}
              >
                {item.description}
              </div>

              <div
                style={{
                  minHeight: "48px",
                  display: "flex",
                  alignItems: "flex-start",
                }}
              >
                {item.link === "/wip" ? (
                  <div className="pointer-events-none cursor-not-allowed opacity-70 wip-button-wrapper">
                    <ActionButton1 data="Coming Soon" showIcon={false} />
                  </div>
                ) : (
                  <Link to={item.link}>
                    <ActionButton1 data="Explore More" />
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      <section className="why-section">
        <div className="fit-text-container">
          <h1 className="background-title">UTah Verticals</h1>
        </div>

        <h2 className="section-heading">Why These Verticals Matter?</h2>

        <p className="section-description">
          These industries reflect Utah’s present strengths and future focus.
          They guide education, workforce development, and policy planning
          offering pathways for residents and opportunities for investors and
          innovators alike.
        </p>
        <div style={{ margin: "40px 0" }}>
          <ActionButton data="Contact Us" link="/contact-us" />
        </div>
      </section>
      <Footer />
    </>
  );
};

export default UtahVerticals;
